import { render, staticRenderFns } from "./PermissionAssignment.vue?vue&type=template&id=6aa69730&scoped=true"
import script from "./PermissionAssignment.vue?vue&type=script&lang=js"
export * from "./PermissionAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa69730",
  null
  
)

export default component.exports